import Vue from "vue";
import Vuex from "vuex";
import axios from "@/directives/axios.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    evangelioDia: "",
    lecturaDia: "",
    allImagenes: [],
    allGalerias: [],
    allNoticias: [],
    allNoticiasTotal: [],
    darkMode: false,
    // Usuario del panel (GET /perfil). Sus permisos deciden qué secciones ve.
    usuario: null,
  },

  getters: {
    usuario(state) {
      return state.usuario;
    },
    permisos(state) {
      return (state.usuario && state.usuario.permisos) || [];
    },
    // Uso: $store.getters.puede("noticias.gestionar")
    puede(state, getters) {
      return (permiso) => getters.permisos.includes(permiso);
    },
    isDarkMode(state) {
      return state.darkMode;
    },
    getEvangelioDia(state) {
      return state.evangelioDia;
    },
    getLecturaDia(state) {
      return state.lecturaDia;
    },
    getAllImages(state) {
      return [...state.allImagenes].reverse();
    },
  },

  mutations: {
    setUsuario(state, usuario) {
      state.usuario = usuario || null;
    },
    changeDarkMode(state, value) {
      state.darkMode = value;
    },
    changeEvangelioDia(state, data) {
      state.evangelioDia = data;
    },
    changeLecturaDia(state, data) {
      state.lecturaDia = data;
    },
    setAllGalerias(state, galerias) {
      state.allGalerias = galerias;
    },
    setAllImages(state, imagenes) {
      state.allImagenes = imagenes;
    },
  },

  actions: {
    async cargarUsuario({ commit }) {
      const response = await axios.get("/perfil");
      commit("setUsuario", response.data.usuario);
      return response.data.usuario;
    },

    async inicialTodasGalerias({ commit }) {
      const response = await axios.get("/imagenes/todasGalerias");
      commit("setAllGalerias", response.data.todasGalerias || []);
    },

    async changeAllImages({ commit }) {
      const response = await axios.get("/imagenes");
      commit("setAllImages", response.data.imagenes || []);
    },

    async initialDataChange({ dispatch }) {
      await Promise.all([
        dispatch("changeAllImages"),
        dispatch("inicialTodasGalerias"),
      ]);
    },
  },

  modules: {},
});
